import { Loading } from "@corecrm/ui";
import { useEffect, useRef, useState } from "react";
import { pageLoad, useClaimImpersonation } from "../api/queries";
import { PublicShell } from "../components/bits";

/** The token from the staff app's "Log in as" link (UX-152). It's in the fragment, so it never
    reaches a server log, and it's wiped from the address bar straight away. */
export function handoffToken(hash: string): string {
  return new URLSearchParams(hash.replace(/^#/, "")).get("token") ?? "";
}

/** /impersonate#token=…: an administrator arriving from CoreCRM's "Log in as" a client. */
export function ImpersonatePage() {
  const [token] = useState(() => handoffToken(window.location.hash));
  const claim = useClaimImpersonation();
  const started = useRef(false);

  useEffect(() => {
    if (started.current || !token) return; // once, even under StrictMode's double effect
    started.current = true;
    window.history.replaceState(null, "", window.location.pathname);
    // A full page load, so nothing cached for anyone else shows.
    claim.mutate(token, { onSuccess: () => pageLoad.goTo("/") });
  }, [token, claim]);

  if (!token || claim.isError)
    return (
      <PublicShell title="Log in as">
        <h1>This Log in as link has expired</h1>
        <p className="muted">
          Log in as links work once, for two minutes. Go back to CoreCRM and choose Log in as again.
        </p>
      </PublicShell>
    );
  return (
    <PublicShell title="Logging in">
      <Loading label="Logging you in as the client…" />
    </PublicShell>
  );
}
